import { Link as RouterLink } from "@tanstack/react-router";
import Link from "@mui/material/Link";

export const faqList = [
  {
    question:
      "How do I contact customer support if I have a question or issue?",
    answer: (
      <>
        You can reach our customer support team by emailing{" "}
        <Link
          underline="none"
          sx={{ color: "primary.main" }}
          href={`mailto:support@peterdrew.com`}
        >
          support@peterdrew.com
        </Link>{" "}
        or calling{" "}
        <Link
          underline="none"
          sx={{ color: "primary.main" }}
          href="tel:+441789774777"
        >
          01789 774777
        </Link>
        .
      </>
    ),
  },
  {
    question: "How do I place an order?",
    answer: (
      <>
        <p>
          To place a new order, click on the "New Order" button located on the
          sidebar, or use the "Start Order" button available on the dashboard.
        </p>
        <p>
          Next, click the "Add Staff" button to include staff members in the
          order. You can add multiple staff members to the order if all items
          are required at the same address.
          <br /> If the staff member you are looking for is not listed, you can
          add them by clicking the "Add Staff" button and filling in their
          details. Please note that this action is permissions dependent.
        </p>
        <p>To add items to the order, please follow these steps:</p>
        <ol>
          <li>
            Click on the blue shopping cart icon next to the name of the person
            you wish to order for.
          </li>
          <li>
            Browse through the available items and select the ones you need.
            Choose the colour, size and quantity required.
          </li>
          <li>
            Click on the "Add to Order" button next to each item you want to
            include.
          </li>
        </ol>
        <p>Select an order reason and click "Next".</p>
        <p>
          Choose your delivery address. You can either select an address from
          the address book or create a new address. Click "Next" to confirm the
          address and select your shipping options.
        </p>
        <p>
          On the Shipping Options page, you have the option to 'split' your
          order, allowing you to receive some items more quickly if needed.
          Please note that this may incur an additional delivery charge. You can
          also select the delivery service level on this page.
        </p>
        <p>
          Enter a purchase order number and submit your order. You will receive
          an email confirmation once your order has been successfully submitted.
          <br />A copy of the order can be downloaded before submitting by
          clicking the "Download Order" button.
        </p>
      </>
    ),
  },
  {
    question: "How do I track my order?",
    answer: (
      <>
        To track an order, click on the "Orders" tab on the sidebar. Under
        "Received Orders", you will see orders that are currently being
        processed. Once an order has been dispatched, it will move to the
        "Completed Orders" section. Click on the order number to view the order
        details and tracking information. By clicking on the tracking status
        icon, you will be taken to the courier's website where you can track the
        delivery.
      </>
    ),
  },
  {
    question: "How do I register staff?",
    answer: (
      <>
        To register staff, click on the "Staff" tab on the sidebar, then click
        on the "Add Staff" button. Fill in the staff member's details and click
        "Save" to add them to the system.
        <br />
        Please note, this action is permissions dependent.
      </>
    ),
  },
  {
    question:
      "How do I edit a staff members details, such as branch, contract, or wardrobe?",
    answer: (
      <>
        To edit a staff member's details, click on the "All Staff" tab on the
        sidebar, then click on the "Edit" button next to the staff member you
        wish to update. Make the necessary changes and click "Save" to confirm.
        <br />
        Please note, this action is permissions dependent.
      </>
    ),
  },
  {
    question:
      "Can I move a member of staff from a branch I do not have access to one of my own branches?",
    answer: (
      <>
        Yes, if you have the "Global Staff" permission, you can move a member of
        staff from a branch you do not have access to one of your own branches.
        <br />
        To do this, click on the "All Staff" button on the sidebar, then change
        the Branch Filter dropdown to the "All Branches" option. You will now
        see staff outside of your allocated branches. (If the "All Branches"
        option is disabled you do not have the "Global Staff" permission)
        <br />
        Find the staff member you wish to move, click on the "Edit" button, and
        select the new branch from the dropdown list. Click "Save" to confirm.
      </>
    ),
  },
  {
    question: "How do I delete a staff member?",
    answer: (
      <>
        To delete a staff member, click on the "Active Staff" tab on the
        sidebar, then click on the "Edit" button next to the staff member you
        wish to delete. Click the "Blocked" checkbox, then click "Save" to
        confirm. They will be moved to the "Innactive Staff" list.
        <br />
        Please note, this action is permissions dependent.
      </>
    ),
  },
  {
    question: "How do I add a new delivery address?",
    answer: (
      <>
        A new delivery address can be added during the order creation process or
        from the "Addresses" tab on the "My Account" page. Click on the "New
        Address" button, fill in the details and click "Save" to add the address
        to your address book.
      </>
    ),
  },
  {
    question: "How do I delete delivery address?",
    answer: (
      <>
        To delete a delivery address, click on the "Addresses" tab on the "My
        Account" page. Find the address you wish to delete and click the
        "Delete" button next to it. Confirm the deletion when prompted.
        Addresses can also be deleted while creating an order.
      </>
    ),
  },
  {
    question: "How do I change my default delivery address?",
    answer: (
      <>
        To change your default delivery address, click on the "Addresses" tab on
        the "My Account" page. Find the address you wish to set as default and
        click the "Set as Default" button.
      </>
    ),
  },
  {
    question: "How do I change my password?",
    answer: (
      <>
        You can change your password by clicking on the "Change Password" button
        in the "My Account" section. Enter your email address, and click send
        verification code. Enter the code you receive via email, and then enter
        your new password and confirm it. Click "Save" to update your password.
      </>
    ),
  },
  {
    question: "How do I return an order?",
    answer: (
      <>
        <p>
          Orders can be returned by clicking on the "Returns" tab on the
          sidebar. Click on the "Start Return" button and enter the invoice
          number of the order you wish to return. If you do not know the invoice
          number, please go the the "Completed Orders" section to find it.
        </p>
        <p>Complete the return and collection address details.</p>
        <p>
          Select the items you wish to return and the reason for the return.
        </p>
        <p>Click "Submit" to complete the return process.</p>
        <p>
          If the items are non-returnable or outside of the return window then
          you will not be able to submit the return. Please contact customer
          support if you think you should be able to return the order.
        </p>
      </>
    ),
  },
  {
    question: "How do I create or edit a wardrobe?",
    answer: (
      <>
        Please complete the form on the{" "}
        <Link
          component={RouterLink}
          underline="none"
          sx={{ color: "primary.main" }}
          to="/wardrobe-request"
        >
          wardrobe request page.
        </Link>
        <br />
        <p>Please note this is permissions dependent</p>
      </>
    ),
  },
  {
    question: "How do see my access level?",
    answer: (
      <>
        You can view your access level by clicking on the "Access" tab on the
        "My Account" page. Your current access level will be displayed at the
        top of the page.
        <br />
        Details of your permissions will be shown below your access level.
      </>
    ),
  },
  {
    question: "How do I change my access level?",
    answer: (
      <>
        To change your access level, please contact support. We will need the
        permission of your line manager to make any changes.
      </>
    ),
  },
  {
    question: "How do see my assigned branches?",
    answer: (
      <>
        You can view the branches you have access to by clicking on the
        "Branches" tab on the "My Account" page.
      </>
    ),
  },
  {
    question: "How do I change the branches I have access to?",
    answer: (
      <>
        To change your access level, please contact support. We will need the
        permission of your line manager to make any changes.
      </>
    ),
  },
  {
    question: "How do I have a new account created for someone else?",
    answer: (
      <>
        Please contact support, please let us know the name, email address, and
        mobile no. of the person, and what access they require.
      </>
    ),
  },
  {
    question: "How do I delete my account?",
    answer: (
      <>
        Please contact support.
        <br />
        You can reach our customer support team by emailing{" "}
        <Link
          underline="none"
          sx={{ color: "primary.main" }}
          href={`mailto:support@peterdrew.com`}
        >
          support@peterdrew.com
        </Link>
      </>
    ),
  },
];
